/**
 * Tải + kiểm tra tương thích WVM.
 * Viewer đọc `wvmVersion` (pattern ^1\.\d+$). Major khác 1 → từ chối (cần cập nhật viewer).
 */
import { getPayload } from '../lib/api/client';
import type { WvmDocument } from '../lib/types/wvm';

export class UnsupportedVersionError extends Error {
  constructor(readonly version: string) {
    super(`Phiên bản mô hình không hỗ trợ: ${version}`);
    this.name = 'UnsupportedVersionError';
  }
}

export class EmptyModelError extends Error {
  constructor() {
    super('Mô hình không có chi tiết nào.');
    this.name = 'EmptyModelError';
  }
}

const SUPPORTED_MAJOR = 1;

export function majorVersion(v: string): number {
  return Number.parseInt(v.split('.')[0] ?? '', 10);
}

/** Lấy payload từ backend, kiểm version + rỗng. Ném lỗi có kiểu để UI phân loại. */
export async function loadModel(
  token: string,
  authKey?: string | null,
  signal?: AbortSignal,
): Promise<WvmDocument> {
  const doc = await getPayload(token, authKey, signal);

  if (majorVersion(doc.wvmVersion) !== SUPPORTED_MAJOR) {
    throw new UnsupportedVersionError(doc.wvmVersion);
  }
  if (!Array.isArray(doc.parts) || doc.parts.length === 0) {
    throw new EmptyModelError();
  }
  return doc;
}
